module.exports = __webpack_public_path__ + "static/media/girl-mekup-1.a50d0bed.png";